var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27177 18.3446C7.91186 18.7045 7.90451 19.3435 8.27911 19.7181C8.66106 20.0927 9.30008 20.0854 9.65264 19.7328L14.0009 15.3845L18.3419 19.7255C18.7091 20.0927 19.3408 20.0927 19.7154 19.7181C20.09 19.3362 20.09 18.7119 19.7227 18.3446L15.3818 14.0037L19.7227 9.6554C20.09 9.28815 20.0973 8.65647 19.7154 8.28187C19.3408 7.90728 18.7091 7.90728 18.3419 8.27453L14.0009 12.6155L9.65264 8.27453C9.30008 7.91462 8.65371 7.89993 8.27911 8.28187C7.90451 8.65647 7.91186 9.30284 8.27177 9.6554L12.6127 14.0037L8.27177 18.3446Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.39005a0fa5475287f1cbcc45dd85da1f.svg";
export { ForwardRef as ReactComponent };